import Box from "@mui/material/Box"
import Image from "next/image"


const IsDesignerOriginalImage = () => {
  return (
      <Box className='position-absolute d-flex' sx={{bottom:'2%', left:'1%', objectFit: 'cover' ,width:'40%', height:'40%'}}>
          <Image src={'/images/designer-original-white-new.png'} alt="Designer Image" loading="lazy" fill quality={75} sizes='10vw'/>
      </Box>
  )
}

export default IsDesignerOriginalImage